import type { Role } from "../api/types";

export function homePathForRole(role: Role): string {
  if (role === "maintenance") return "/maintenance";
  return "/dashboard";
}
